import { jsx as _jsx } from "react/jsx-runtime";
import { ElementRenderer, generateElementKey } from '../ElementRenderer.js';
import { getLayoutStyles } from '../layout.js';
import { cn } from '../lib/utils.js';
import { Card as ShadcnCard } from '../ui/card.js';
export function Card({ element }) {
    const layoutStyles = getLayoutStyles(element);
    // Convert numeric styles to Tailwind-compatible inline styles
    const style = {
        ...layoutStyles,
    };
    return (_jsx(ShadcnCard, { className: cn('bg-card'), style: style, children: element.children.map((child, index) => (_jsx(ElementRenderer, { node: child }, generateElementKey(child, index)))) }));
}
//# sourceMappingURL=Card.js.map